import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    Userlist:[],
    semesterList:[],//学年学期列表
    courseTypeList:[],//课程类型列表
    org_time_table:{  // 机构-延时课表数据
      school_arr:[],  // 学校列表
      school_obj:{},  // 学校id-校区映射
      course_arr:[],  // 机构课程列表
      teacher_arr:[], // 机构授课教师列表
      semester_obj:{},  // 学校id-学期学年映射
    },
    isSchool: false,
  },
  mutations: {
    setSemesterList: (state, payload) => {
      state.semesterList = payload;
    },
    setCourseTypeList: (state, payload) => {
      state.courseTypeList = payload;
    },
    setOrgTimeTable: (state, payload) => {
      if(payload.school_arr){
        state.org_time_table.school_arr = payload.school_arr;
      }
      if(payload.school_obj){
        state.org_time_table.school_obj = payload.school_obj;
      }
      if(payload.course_arr){
        state.org_time_table.course_arr = payload.course_arr;
      }
      if(payload.teacher_arr){
        state.org_time_table.teacher_arr = payload.teacher_arr;
      }
      if(payload.semester_obj){
        state.org_time_table.semester_obj = payload.semester_obj;
      }
    },
    updateIsSchool(state, payload = false){
      state.isSchool = payload;
    },
  },
  actions: {
  },
  modules: {
  }
})
